import { ArrowRight } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { SectionCard } from './SectionCard';
import type { GuestState } from './useBookingWorkspace';

const PILL = {
  done: ['Abgeschlossen', 'bg-forest-soft text-forest-deep'],
  open: ['Noch offen', 'bg-amber-tint text-amber-ink'],
  loading: ['Stand wird geladen', 'bg-card-alt text-ink'],
  error: ['Nicht geladen', 'bg-sealwax-tint text-sealwax'],
  hidden: ['Für Ihr Konto verborgen', 'bg-card-alt text-ink'],
} as const;

const TEXT: Record<GuestState, string> = {
  ready: 'Gastprofil und Mailverlauf stehen unter Gast.',
  none: 'Noch kein Gastprofil – es entsteht mit dem Onboarding.',
  loading: 'Gastprofil wird geladen …',
  error: 'Das Gastprofil konnte nicht geladen werden – unter Gast erneut versuchen.',
  hidden:
    'Die Gastdaten sind für Ihr Konto nicht freigegeben; Mailverlauf und Links stehen unter Gast.',
};

/** Onboarding im Überblick: abgeschlossen, offen – oder ehrlich unbekannt, statt „lädt“ für immer. */
export function OverviewOnboardingCard({
  guestState,
  onboardingComplete,
  onOpen,
}: {
  guestState: GuestState;
  onboardingComplete: boolean | null;
  onOpen: () => void;
}) {
  const pill =
    onboardingComplete === true
      ? PILL.done
      : onboardingComplete === false
        ? PILL.open
        : guestState === 'error'
          ? PILL.error
          : guestState === 'hidden'
            ? PILL.hidden
            : PILL.loading;
  return (
    <SectionCard icon="Mail" title="Onboarding">
      <span className={cn('rounded-pill self-start px-2.5 py-1 text-xs font-bold', pill[1])}>
        {pill[0]}
      </span>
      <p className="text-ink-soft text-sm">{TEXT[guestState]}</p>
      <button
        type="button"
        onClick={onOpen}
        className="text-forest mt-auto inline-flex min-h-11 items-center gap-1.5 self-start text-sm font-bold"
      >
        Onboarding ansehen <ArrowRight size={15} aria-hidden />
      </button>
    </SectionCard>
  );
}

/** Was der Überblick noch nicht weiß – dann gibt es kein „Gerade nichts offen“. */
export function unknownSources(
  guestState: GuestState,
  onboardingComplete: boolean | null,
  invoiceState: string | null,
  invoicesFailed: boolean,
): string[] {
  const onboarding =
    guestState === 'hidden'
      ? 'Onboarding für Ihr Konto nicht sichtbar'
      : guestState === 'error'
        ? 'Onboarding nicht geladen'
        : 'Onboarding wird geladen';
  return [
    ...(onboardingComplete === null ? [onboarding] : []),
    ...(invoiceState === null
      ? [invoicesFailed ? 'Rechnungen nicht geladen' : 'Rechnungen werden geladen']
      : []),
  ];
}
